module.exports = __webpack_public_path__ + "img/home_quanwu_zhineng.5eaae107.png";